import React, { ReactElement, useContext, useEffect, useState } from 'react'
import axios from 'axios'
import { ArtData } from '@/database/art'
import { Context } from '@/components/Context'
import serverConfig from '@/server-config'
import AuctionCard from '@/components/auction/AuctionCard'
import { Transaction } from '@/database/transaction'
import { ArtState, TransactionType } from '@/database/types'
import { SpecificUpdate, UpdateSpecific, UpdateSpecificType } from '@/types/websocket'
import PersonalWallet from '@/components/wallets/PersonalWallet'
import VaultWallet from '@/components/wallets/VaultWallet'

axios.defaults.baseURL = serverConfig.baseURL

const filterBids = (transactions: Transaction[]) => {
    if (transactions?.length > 0) {
        return transactions.filter((transaction: Transaction) => {
            return transaction.type === TransactionType.BID
        })
    }
}

const ListingOverview = ({
    openModalAuctionCardDetails,
    myArt,
    myBids,
    myClaims,
    forced,
}: {
    openModalAuctionCardDetails: (artData: ArtData) => void
    myArt: boolean
    myBids: boolean
    myClaims: boolean
    forced: boolean
}): ReactElement => {
    const { auctionDataList, currentAccount, setActiveSpecificUpdates, transactionUserArray } = useContext(Context)
    const [bids, setBids] = useState(filterBids(transactionUserArray[currentAccount ?? ''] as Transaction[]))

    const filteredArt = (auctionDataList: ArtData[]) =>
        auctionDataList.filter((artData) => {
            if (forced && artData.art.state === ArtState.FORCED_AUCTION) {
                if (
                    myArt &&
                    !(artData.art.user.walletAddress === currentAccount || artData.art.currentOwner === currentAccount)
                ) {
                    return false
                }
                if (myClaims && !artData.claims.some((claimData) => claimData.user.walletAddress === currentAccount)) {
                    return false
                }
                return !(bids && !bids.some((transaction) => artData.art.id === transaction.art.id))
            } else if (!forced) {
                if (
                    myArt &&
                    (artData.art.user.walletAddress === currentAccount || artData.art.currentOwner === currentAccount)
                ) {
                    return true
                }
                if (myArt && !myBids && !myClaims) {
                    return false
                }
                if (myClaims && !artData.claims.some((claimData) => claimData.user.walletAddress === currentAccount)) {
                    return false
                }
                if (bids?.some((transaction) => artData.art.id === transaction.art.id)) {
                    return true
                }
            }
            return !myArt && !myBids && !myClaims && !forced
        })

    useEffect(() => {
        setBids(filterBids(transactionUserArray[currentAccount ?? ''] as Transaction[]))
    }, [transactionUserArray, currentAccount])

    useEffect(() => {
        setActiveSpecificUpdates({
            updates: [
                {
                    type: UpdateSpecificType.TRANSACTION_USER,
                    id: currentAccount,
                } as UpdateSpecific,
            ],
        } as SpecificUpdate)
    }, [transactionUserArray[currentAccount ?? ''], currentAccount])

    return (
        <div className="container">
            <div className="prompts">
                <ul>
                    {filteredArt(auctionDataList).map((art) => (
                        <div key={art.art.id}>
                            <div className="bottom">
                                <AuctionCard artData={art} openModalAuctionCardDetails={openModalAuctionCardDetails} />
                            </div>
                            <div className="bottom">
                                {art.nft?.vaultWallet && <VaultWallet wallet={art.nft.vaultWallet} />}
                            </div>
                            {art.nft?.personalWallet && <PersonalWallet wallet={art.nft.personalWallet} />}
                        </div>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default ListingOverview
